/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetStatisticsPathParams = NonNullable<operations['getStatistics']['parameters']['path']>;

export type GetStatisticsQueryParams = NonNullable<operations['getStatistics']['parameters']['query']>;

export interface Input extends GetStatisticsPathParams {
  apiVersion?: string;
  query?: GetStatisticsQueryParams;
}

export async function getStatistics(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/code-refs/statistics/{projectKey}', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
